type IconProps = {
  style?: React.CSSProperties;
};

export const AddImageIcon = ({ style = {} }: IconProps) => {
  return (
    <img
      src="/assets/icons/add-image-icon.svg"
      alt="Add icon"
      style={{ height: '2.4rem', ...style }}
    />
  );
};
